export default "__VITE_ASSET__mhC5vj2g__ 300w";